import { Dialog } from "@mui/material";
import { fullMenuConfig } from "components/portfolio/GridViewFunction/CoverageStatus";
import { useEPRevampDataById } from "components/summary/hooks";
import FloatProgressBar from "components/summary/lifecycle-adoption/FloatProgressBar";
import {
  SuccessPlanContext,
  SuccessPlanEditWorkflow,
  SuccessPlanHeader,
  SuccessPlanLayout,
  SuccessPlanProfile,
  SuccessPlanSectionGroup,
  getStepIndicator,
} from "components/summary/success-plan";
import { riskItems } from "components/summary/success-plan/constants";
import {
  initialState,
  successPlanReducer,
} from "components/summary/success-plan/state/successPlan.reducer";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { FEATURE_KEY } from "constant";
import { AuthProvider } from "pages";
import { useContext, useEffect, useReducer } from "react";
import { Account } from "types/portfolio";

type SuccessPlanPageProps = {
  account: Account;
};

const SuccessPlanPage = ({ account }: SuccessPlanPageProps) => {
  const { features } = useContext(AuthProvider);
  const { data, mutate: mutateEpRevamp } = useEPRevampDataById(account.accountId);

  const coverageStatusItems = fullMenuConfig.map((item) => ({
    label: item.label,
    color: item.color,
    priority: item.priority,
  }));
  const stepIndicator = getStepIndicator(features ?? []);

  const [state, dispatch] = useReducer(successPlanReducer, initialState);

  const handleCancelEdit = () => {
    dispatch({ type: "setMode", payload: "view" });
    dispatch({ type: "setStepIndicator", payload: stepIndicator });
  };

  useEffect(() => {
    if (!account || !data) {
      return;
    }
    dispatch({
      type: "hydrate",
      payload: {
        account,
        selectedAccounts: data.accounts,
        spData: data,
        stepIndicator: stepIndicator,
      },
    });
  }, [account, data, stepIndicator]);

  if (state.status === "loading" || state.status === "idle") {
    return (
      <FloatProgressBar
        label="Processing..."
        variant="solid"
      />
    );
  }

  return (
    <Dialog
      open={true}
      scroll="paper"
      fullWidth={true}
      maxWidth={"xl"}
      fullScreen={true}
      disableEnforceFocus={true}
    >
      <SuccessPlanContext.Provider
        value={{
          dispatch,
          riskItems: riskItems,
          coverageStatusItems: coverageStatusItems,
        }}
      >
        <SuccessPlanLayout
          header={
            <SuccessPlanHeader
              mutateEpRevamp={mutateEpRevamp}
              spState={state}
            />
          }
          profile={<SuccessPlanProfile spState={state} />}
          sectionGroup={<SuccessPlanSectionGroup spState={state} />}
        />
        {state.mode === "edit" && (
          <SuccessPlanEditWorkflow
            open={state.mode === "edit"}
            onClose={handleCancelEdit}
            spState={state}
          />
        )}
      </SuccessPlanContext.Provider>
    </Dialog>
  );
};

export default SuccessPlanPage;
